'use strict';

var React = require('react');

/* Stores */
var LanguageStore = require('stores/language');

var SideBarPanel = React.createClass({
  displayName: 'SideBarPanel',

  render: function render() {
    var component = this;

    var _component$props = component.props;
    var key = _component$props.key;
    var children = _component$props.children;

    /* Translations */
    var translate = LanguageStore.translate;
    var titleTranslation = translate('sidebar_panel_header_title_' + key);

    return React.createElement(
      'div',
      { className: 'sidebar-panel-component' },
      React.createElement(
        'div',
        { className: 'header' },
        children.props.title
      ),
      React.createElement(
        'div',
        { className: 'content' },
        children
      )
    );
  }
});

module.exports = SideBarPanel;


/** WEBPACK FOOTER **
 ** ../~/babel-loader!./js/components/project/sidebar/panel.js
 **/